import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiClientConfig} from './api-client-config';
import { GetLogLevelResponse } from 'it/primatoo/openapi/api/common/schemas/GetLogLevelResponse';
import { LogLevel } from 'it/primatoo/openapi/api/common/schemas/LogLevel';
import { GetSupportInfoResponse } from 'it/primatoo/openapi/api/common/schemas/GetSupportInfoResponse';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  private readonly endpointAdmV1: string;
  private readonly endpointOrgV1: string;
  private readonly endpointSecV1: string;

  private readonly endpointAdmV2: string;
  private readonly endpointOrgV2: string;
  private readonly endpointSecV2: string;



  constructor(@Inject(ApiClientConfig) private config: ApiClientConfig,
              private httpClient: HttpClient) {
    this.endpointAdmV1 = this.config.endPoint + `/api/adm`;
    this.endpointOrgV1 = this.config.endPoint + `/api/org`;
    this.endpointSecV1 = this.config.endPoint + `/api/sec`;

    this.endpointAdmV2 = this.config.endPoint + `/api/adm/v2`;
    this.endpointOrgV2 = this.config.endPoint + `/api/org/v2`;
    this.endpointSecV2 = this.config.endPoint + `/api/sec/v2`;
  }

  public getSupportInfo(): Observable<GetSupportInfoResponse> {
    const url = this.endpointOrgV2 + `/system/support-info/`;
    return this.httpClient.get<GetSupportInfoResponse>(url);
  }

  public takeStorages(): Observable<{datasources: Array<{id: string, name: string}>}> {
    const url = this.endpointAdmV1 + `/datasources/`;
    return this.httpClient.get<{datasources: Array<{id: string, name: string}>}>(url);
  }

  public getOrgHeartbeat(): Observable<unknown> {
    const url = this.endpointOrgV1 + `/system/heartbeat/`;
    return this.httpClient.get<unknown>(url);
  }

  public upsertOrgLogLevel(level: LogLevel): Observable<unknown> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('X-Domain', 'primatoo');
    const url = this.endpointOrgV2 + `/system/log-level/${level}/`;
    return this.httpClient.put<unknown>(url, {}, { headers: header });
  }

  public getOrgLogLevel(): Observable<GetLogLevelResponse> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('X-Domain', 'primatoo');
    const url = this.endpointOrgV2 + `/system/log-level/`;
    return this.httpClient.get<GetLogLevelResponse>(url, { headers: header });
  }


  public getSecHeartbeat(): Observable<unknown> {
    const url = this.endpointSecV1 + `/system/heartbeat/`;
    return this.httpClient.get<unknown>(url);
  }

  public upsertSecLogLevel(level: LogLevel): Observable<unknown> {
    const url = this.endpointSecV2 + `/system/log-level/${level}/`;
    return this.httpClient.put<unknown>(url, {});
  }

  public getSecLogLevel(): Observable<GetLogLevelResponse> {
    const url = this.endpointSecV2 + `/system/log-level/`;
    return this.httpClient.get<GetLogLevelResponse>(url);
  }


  public getAdminHeartbeat(): Observable<unknown> {
    const url = this.endpointAdmV1 + `/system/heartbeat/`;
    return this.httpClient.get<unknown>(url);
  }

  public upsertAdminLogLevel(level: LogLevel): Observable<unknown> {
    const url = this.endpointAdmV2 + `/system/log-level/${level}/`;
    return this.httpClient.put<unknown>(url, {});
  }

  public getAdminLogLevel(): Observable<GetLogLevelResponse> {
    const url = this.endpointAdmV2 + `/system/log-level/`;
    return this.httpClient.get<GetLogLevelResponse>(url);
  }
}
